'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var validate = function validate(values) {
  var newPassword = values.newPassword,
      confPassword = values.confPassword;

  var t = require('i18n-universal').getT();
  var errors = {
    _error: null
  };

  if (newPassword && confPassword && newPassword !== confPassword) {
    errors.confPassword = t('Password and confirmation do not match');
  }

  errors._error = (0, _validation.passwordCondition)(newPassword);

  return errors;
};

exports.default = validate;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ForgotPassword/ForgotPasswordFormValidation.js
// module id = 2010
// module chunks = 1